import React from "react";
import {typeProductService} from "../jwt/_services/promotions/typeProductService";

export const typeProductProvider = {
    getOptions,
    getItem,
};

async function getOptions(fbDataBaseId = null){
    try {
        const listItems = await typeProductService.search(0,100, {
            fbDataBase : {  id : fbDataBaseId },
            item : { code: null, }
        } );

        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code,
                    label: <div><label>{itemData.code + ' - ' + itemData.description}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await typeProductService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}